import React from 'react'
import { Link } from 'react-router-dom'

function ConvertibleIdLink({ convertible, children }) {
    const c = convertible.convertible || convertible
    return <Link to={`/convertibles/${c.convertibleId}`}>{children}</Link>
}

export default ConvertibleIdLink
